// ja strings for messages/auth.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const auth: Dict = {
  "auth.continueGoogle": "Googleで続ける",
  "auth.orEmail": "またはメールアドレスで",
  "auth.email": "メールアドレス",
  "auth.emailInput": "メールアドレス入力欄",
  "auth.emailPlaceholder": "you@example.com",
  "auth.password": "パスワード",
  "auth.passwordInput": "パスワード入力欄",
  "auth.passwordPlaceholderNew": "6文字以上",
  "auth.signUp": "新規登録",
  "auth.logIn": "ログイン",
  "auth.signIn": "ログイン",
  "auth.createAccount": "アカウントを作成",
  "auth.createYourAccount": "アカウントを作成",
  "auth.forgotPassword": "パスワードをお忘れですか？",
  // "<agree> [Terms] <and> [Privacy]": the sentence has no tail, so the verb
  // goes first.
  "auth.agree": "次に同意します：",
  "auth.agreeJammable": "Jammableの次の規約に同意します：",
  "auth.and": "と",
  "auth.terms": "利用規約",
  "auth.privacy": "プライバシーポリシー",
  "auth.agreeRequired": "利用規約とプライバシーポリシーに同意してください。",
  "auth.welcomeBack": "おかえりなさい！",
  "auth.welcomeNew": "Jammableへようこそ！",
  "auth.registerError":
    "登録中にエラーが発生しました。もう一度お試しください。",
  "auth.backToLogin": "ログインに戻る",

  "auth.invalidEmail": "メールアドレスが正しくありません",
  "auth.emailRequired": "メールアドレスを入力してください",
  "auth.passwordMin": "パスワードは6文字以上で入力してください",
  "auth.passwordRequired": "パスワードを入力してください",

  "auth.modal.signInTitle": "Jammableにログイン",
  "auth.modal.subtitle": "10万以上のボイスでAIカバーを作成。",
  "auth.modal.signUpButton": "新規登録ボタン",
  "auth.modal.signInButton": "ログインボタン",
  "auth.modal.haveAccount": "アカウントをお持ちですか？",
  "auth.modal.newHere": "はじめての方",
  "auth.modal.createAnAccount": "アカウントを作成",

  "auth.login.heading": "おかえりなさい",
  "auth.login.blurb": "カバー、ボイス、コレクションは前回のまま残っています。",
  "auth.login.noAccount": "アカウントをお持ちでないですか？",

  // "<heading> <highlight>", inverted: どんな声にも歌わせよう、[あなたの音声を]
  "auth.signup.heading": "どんな声にも歌わせよう、",
  "auth.signup.headingHighlight": "あなたの音声を",
  "auth.signup.blurb":
    "10万以上のボイス、カバーをまとめて保存、デュエットや動画も作れるスタジオ。",
  "auth.signup.haveAccount": "すでにアカウントをお持ちですか？",

  "auth.forgot.title": "パスワードを再設定",
  "auth.forgot.blurb":
    "メールアドレスを入力すると、新しいパスワードを設定するリンクをお送りします。",
  "auth.forgot.send": "再設定リンクを送信",
  "auth.forgot.sentToast": "パスワード再設定メールを送信しました！",
  "auth.forgot.sent":
    "送信しました。受信トレイと迷惑メールフォルダを確認してください。",
  // "<google> [Continue with Google] <googleAfter>"
  "auth.forgot.google": "Googleで登録した方は",
  "auth.forgot.googleAfter": "をご利用ください",

  "auth.reset.title": "新しいパスワードを設定",
  "auth.reset.blurb": "6文字以上。次回からこのパスワードでログインします。",
  "auth.reset.newPassword": "新しいパスワード",
  "auth.reset.submit": "パスワードを再設定",
  "auth.reset.success": "パスワードを再設定しました！",
  "auth.reset.expired": "リンクの期限が切れましたか？",
  "auth.reset.sendNew": "新しいリンクを送信",

  "auth.error.google.popup-closed-by-user":
    "ログインが完了する前にポップアップが閉じられました。もう一度お試しください。",
  "auth.error.google.popup-blocked":
    "ポップアップがブラウザにブロックされました。ポップアップを許可して、もう一度お試しください。",
  "auth.error.google.operation-not-supported-in-this-environment":
    "このログイン方法は現在の環境ではご利用いただけません。",
  "auth.error.google.network-request-failed":
    "ネットワークエラーが発生しました。インターネット接続を確認して、もう一度お試しください。",
  "auth.error.google.cancelled-popup-request":
    "複数のログインリクエストが検出されました。もう一度お試しください。",
  "auth.error.google.timeout":
    "ログインに時間がかかりすぎました。インターネット接続を確認して、もう一度お試しください。",
  "auth.error.google.account-exists-with-different-credential":
    "このメールアドレスのアカウントはすでに存在します。登録時と同じ方法でログインしてください。",
  "auth.error.google.invalid-credential":
    "ログイン情報が無効か、期限切れです。もう一度お試しください。",
  "auth.error.google.user-disabled":
    "このアカウントは無効になっています。サポートまでお問い合わせください。",
  "auth.error.google.user-not-found":
    "このメールアドレスのアカウントが見つかりません。もう一度お試しいただくか、新しく登録してください。",
  "auth.error.google.wrong-password":
    "パスワードが正しくありません。もう一度お試しください。",

  "auth.error.signIn.invalid-email":
    "入力したメールアドレスが正しくありません。確認して、もう一度お試しください。",
  "auth.error.signIn.user-disabled":
    "このアカウントは無効になっています。サポートまでお問い合わせください。",
  "auth.error.signIn.user-not-found":
    "このメールアドレスのアカウントが見つかりません。もう一度お試しいただくか、新しく登録してください。",
  "auth.error.signIn.wrong-password":
    "入力したパスワードが正しくありません。もう一度お試しください。",
  "auth.error.signIn.too-many-requests":
    "ログインの失敗が続いています。しばらくしてから、もう一度お試しください。",

  "auth.error.signUp.email-already-in-use":
    "このメールアドレスは別のアカウントで使用されています。別のメールアドレスをお使いください。",
  "auth.error.signUp.invalid-email":
    "入力したメールアドレスが正しくありません。確認して、もう一度お試しください。",
  "auth.error.signUp.operation-not-allowed":
    "現在、新しいアカウントを作成できません。しばらくしてから、もう一度お試しください。",
  "auth.error.signUp.weak-password":
    "パスワードは6文字以上にしてください。より強力なパスワードをお試しください。",

  "auth.error.forgot.invalid-email": "正しいメールアドレスを入力してください。",
  "auth.error.forgot.user-not-found":
    "このメールアドレスのアカウントが見つかりません。",
  "auth.error.forgot.missing-android-pkg-name":
    "Androidパッケージ名が必要です。",
  "auth.error.forgot.missing-continue-uri": "続行用のURLが必要です。",
  "auth.error.forgot.missing-ios-bundle-id": "iOSのバンドルIDが必要です。",
  "auth.error.forgot.unauthorized-continue-uri":
    "指定された続行用のURLは許可されていません。",
  "auth.error.forgot.operation-not-allowed":
    "このプロジェクトではパスワードの再設定が有効になっていません。",

  "auth.error.reset.invalid-action-code":
    "リンクのコードが無効です。リンクを確認して、もう一度お試しください。",
  "auth.error.reset.expired-action-code":
    "リンクのコードの期限が切れています。パスワード再設定メールをもう一度リクエストしてください。",
  "auth.error.reset.user-disabled":
    "このアカウントは無効になっています。サポートまでお問い合わせください。",
  "auth.error.reset.user-not-found":
    "このメールアドレスのアカウントが見つかりません。",
  "auth.error.reset.weak-password": "パスワードは6文字以上にしてください。",
  "auth.error.reset.operation-not-allowed":
    "このプロジェクトではパスワードの再設定が有効になっていません。",
  "auth.seo.loginTitle": "ログイン - Jammable",
  "auth.seo.loginDescription": "Jammableアカウントにログインします。",
  "auth.seo.signupTitle": "新規登録 | Jammable",
};

export default auth;
